import { render, staticRenderFns } from "./BaseSelect.vue?vue&type=template&id=2afbb71c&scoped=true"
import script from "./BaseSelect.vue?vue&type=script&lang=js"
export * from "./BaseSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseSelect.vue?vue&type=style&index=0&id=2afbb71c&prod&lang=scss"
import style1 from "./BaseSelect.vue?vue&type=style&index=1&id=2afbb71c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afbb71c",
  null
  
)

export default component.exports